import { Injectable } from '@angular/core';
import { DEFAULT_TTL } from '@shared/constants';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  setLocalStorageItem<T>(
    key: string,
    value: T,
    ttl: number | null = DEFAULT_TTL
  ): void {
    setItem(localStorage, { key, value, ttl });
  }

  getLocalStorageItem<T>(key: string): T | null {
    return getItem(localStorage, key);
  }

  removeLocalStorageItem(key: string): void {
    localStorage.removeItem(key);
  }

  setSessionStorageItem<T>(
    key: string,
    value: T,
    ttl: number | null = DEFAULT_TTL
  ): void {
    setItem(sessionStorage, { key, value: replacer(value), ttl });
  }

  getSessionStorageItem<T>(key: string): T | null {
    return reviver(getItem(sessionStorage, key));
  }
}

// TODO: remove Map from objects or make function recursive
/* eslint-disable @typescript-eslint/no-explicit-any */
function replacer(value: any): unknown {
  for (const property in value) {
    const originalObject = value[property];
    if (originalObject instanceof Map) {
      value[property] = {
        dataType: 'Map',
        value: [...originalObject], // or with spread: value: [...originalObject]
      };
    }
  }
  return value;
}

// TODO: remove Map from objects or make function recursive
function reviver<T>(value: any): T {
  if (value) {
    for (const property in value) {
      const originalObject = value[property];
      if (originalObject?.dataType === 'Map') {
        value[property] = new Map(originalObject.value);
      }
    }
  }

  return value;
}

/* eslint-enable @typescript-eslint/no-explicit-any */

function getItem<T>(storage: Storage, key: string): T | null {
  const itemStr = storage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);

  // compare the expiry time of the item with the current time
  if (item?.expiry && Date.now() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    storage.removeItem(key);
    return null;
  }
  return item.value as T;
}

function setItem(
  storage: Storage,
  { value, ttl, key }: { value: unknown; key: string; ttl: number | null }
): void {
  const item = {
    value,
    expiry: ttl ? Date.now() + ttl : null,
  };
  storage.setItem(key, JSON.stringify(item));
}
